import type { AxiosResponse } from "axios";
import type { PartnerDto, UserDto } from "@/api/api.dto";
import { ApiInstance } from "@/api";
import type { TourState } from "@/stores/onboardingToures/onboardingTours";

export default class USER_API {
  static async getUser(userId: string): Promise<AxiosResponse<UserDto>> {
    return ApiInstance.get<UserDto>(`/user/user/${userId}`);
  }

  static async getPartner(): Promise<AxiosResponse<PartnerDto>> {
    return ApiInstance.get<PartnerDto>("/user/Partner/");
  }

  static async getUsersInPartner(
    userId: string,
  ): Promise<AxiosResponse<UserDto[]>> {
    return ApiInstance.get<UserDto[]>(`/user/usersInPartner?userId=${userId}`);
  }

  static async changeClaims(
    userId: string,
    claimsForRemove: number[],
    claimsForAdd: number[],
  ): Promise<AxiosResponse> {
    return ApiInstance.patch(`/user/changeAccess/${userId}`, {
      claimsForRemove,
      claimsForAdd,
    });
  }

  static async changeUserPosition(
    userId: string,
    newPosition: string,
  ): Promise<AxiosResponse> {
    return ApiInstance.patch(
      `/user/UserPosition/${userId}?newPosition=${newPosition}`,
    );
  }

  static async deleteUser(
    userIdToRemove: UserDto["id"],
  ): Promise<AxiosResponse> {
    return ApiInstance.delete(`/user/${userIdToRemove}`);
  }

  static async changePassword(
    oldPass: string,
    newPass: string,
  ): Promise<AxiosResponse> {
    return ApiInstance.patch("/user/Password", { oldPass, newPass });
  }

  static async updateFullName(
    newFullName: string,
    userId?: UserDto["id"],
  ): Promise<AxiosResponse> {
    return ApiInstance.patch("/user/UserFIO", undefined, {
      params: { newFIO: newFullName, userId },
    });
  }

  static async getOnboardingTourState(): Promise<AxiosResponse> {
    return ApiInstance.get("/User/OnboardingTour");
  }

  static async setOnboardingTourState(
    tourState: TourState,
  ): Promise<AxiosResponse> {
    return ApiInstance.post(
      "/User/OnboardingTour",
      { data: JSON.stringify(tourState) },
      {
        headers: { "Content-Type": "application/json" },
      },
    );
  }
}
